<template>
    <div class="upload-file">
      <b-modal
        id="repRequestfailed"
        centered
        size="md"
        no-close-on-backdrop
        hide-footer
        v-if="row"
      >
        <template #modal-header>
          <div class="repRejectModal-header text-center">
            <h4>Approval Request</h4>
            <b-button variant="close-btn" class='btn-container' @click="closeModal">
              <i class="fas fa-times"></i>
            </b-button>
          </div>
        </template>
        <b-container fluid>
          <div class="repRejectModal-form text-center">
            <div class=""><img src="../../../assets/images/fail.svg" alt=""></div>
            <div class="mb-2">Approving <span class="failed">Request Failed !!</span></div>
            <div class="mb-2">Approving Request Failed might be network issue occurred while processing your payment</div>
            <div class="try-again">Try Again</div>
          </div>
        </b-container>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    name: "RepRejectModal",
    props: {
      row: {
        required: true,
      },
    },
    methods: {
      reset() {
        this.$emit("update:row", null);
      },
      closeModal() {
        this.$bvModal.hide("repRejectModal");
        this.reset();
      },
    },
  };
  </script>
  
  <style>
  .try-again{
    color: #12B4DE;
    margin-top: 1rem;
    font-weight: 500;
    margin-bottom: 0.8rem;
  }
  .repRejectModal-form .failed{
    color: red;
  }
  .repRejectModal-header h4 {
    font-size: 20px;
    color: #2c3f58;
    font-weight: 600;
  }
  .repRejectModal-header p {
    font-size: 14px;
    color: #2c3f58;
  }
  .repRejectModal-header button {
    position: absolute;
    top: -15px;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .repRejectModal-form label{
    display: block;
    color: #5e5e5e;
      font-size: 14px;
      margin-bottom: 8px;
      font-weight: 500;
  }
  .repRejectModal-form .custom-field{
        width: 100%;
      border: 1px solid #dce1e7;
      outline: none;
      border-radius: 6px;
      padding: 9px 15px;
      font-size: 14px;
      transition: all ease 0.6s;
  }
  .univ-btnEdit, .univ-btnEdit:focus{
    background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
      border-radius: 6px;
      color: #fff;
      outline: none;
      border: 0;
      width: 100%;
      text-align: center;
      padding: 10px 0;
      margin-top: 10px;
      transition: all ease 0.6s;
      box-shadow: inherit;
  }
  .modal-content{
      border: 0;
      border-radius: 15px;
  }
  .modal-header{
      justify-content: center;
      border: 0;
      padding: 25px 0;
      position: relative;
  }
  .repRejectModal-header .btn-container  {
    position: absolute;
    top: -14px !important;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  </style>
  